"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

function getOffsetFromPath(pathname: string): number {
  if (/^\/mutual-fund\/[^/]+\/[^/]+\/mso\d+$/.test(pathname)) {
    return -150;
  }
  return -96;
}

export default function ScrollToHash() {
  const pathname = usePathname();
  const searchParams = useSearchParams(); 

  useEffect(() => { 
    if (
      typeof window === "undefined" ||
      pathname === "/404" ||
      pathname === "/_not-found"
    ) {
      return;
    }

    const hash = window.location.hash;
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        const yOffset = getOffsetFromPath(pathname);
        const y =
          el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [pathname, searchParams]);

  return null;
}
